import { apiClient } from "../../../shared/api/client";
import { TRANSACTION_ENDPOINTS } from "./endpoints";

export interface FlagTransactionPayload {
  transactionId: string;
  status?: string;
  issue: string;
  role?: string;
  note?: string;
}

/**
 * Flag a transaction for suspicious activity or discrepancies.
 * Endpoint: POST /v1/admin/transaction/:id
 */
export const flagTransaction = async ({
  transactionId,
  status = "Flagged",
  issue,
  role,
}: FlagTransactionPayload): Promise<any> => {
  const body: Record<string, any> = {
    status,
    issue,
  };
  if (role) {
    body.role = role;
  }
  // note is commented out because backend DTO strictly rejects unrecognized property:
  // if (note) {
  //   body.note = note;
  // }

  const response = await apiClient.post(
    TRANSACTION_ENDPOINTS.SINGLE_TRANSACTION(transactionId),
    body
  );
  return response.data;
};

